import * as React from "react";
import { AuditModal } from "../../auditmodal/components/AuditModal";
import { useWebPortalLegacyClient } from "../../misc/api/WebPortalTokenClient";

interface RemoveLinkedModalProps {
    selectedAnalysisSet: string;
    onClose: () => void;
}

const RemoveLinkedModal = ({ selectedAnalysisSet, onClose }: RemoveLinkedModalProps): JSX.Element => {
    const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);
    const [error, setError] = React.useState<string>(null);
    const legacyClient = useWebPortalLegacyClient();

    const resetModal = () => {
        setIsSubmitting(false);
        setError(null);
    }

    const resetModalAndClose = () => {
        resetModal();
        onClose();
    }

    return (
        <AuditModal error={error} header="Confirm Removal Of Linked Analysis Set" isSubmitting={isSubmitting} onClose={() => {
            resetModalAndClose();
        }} onSubmit={(values) => {
            setIsSubmitting(true);
            setError(null);
            legacyClient.removeLinkedAnalysisSet(selectedAnalysisSet, values.Annotation).then(() => {
                resetModalAndClose();
            }).catch(err => {
                setError(err.Message);
                setIsSubmitting(false);
            });
        }} />
        
    );
};

export default RemoveLinkedModal;
